<script>
import ListingModel from "@/views/Debt/Components/ListingModel.vue";

export default {
    components: {ListingModel}
}
</script>

<template>
  <div>
    <ListingModel :pay_day_advance="true"></ListingModel>
  </div>
</template>